var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.739 0.000274096H15.8426V2.46761H20.739C22.2924 2.46761 23.5517 3.73685 23.5517 5.30227C23.5517 6.86769 22.2923 8.13693 20.739 8.13693L4.68694 8.13801L9.29988 3.48897L7.56905 1.7446L0 9.37177L7.569 17L9.29983 15.2556L4.68689 10.6055H20.739C23.6406 10.6055 26 8.22757 26 5.30329C26 2.37899 23.6405 0 20.739 0L20.739 0.000274096Z",
    fill: "#1A1346"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic-back.889955a7e09b7c4f0083db02943ebf52.svg";
export { ForwardRef as ReactComponent };